import ArrowRight from '@/assets/icons/arrow-right.svg?react'
import { Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import { Link } from 'react-router-dom'

export const BackToListButton = ({ href, text }: { href: string; text?: React.ReactNode }) => {
  return (
    <Link type="button" className="hover:text-orange flex items-center gap-2" to={href}>
      <ArrowRight className="h-5 w-8 rotate-180" /> <Text>{text ?? <Trans>Back to list</Trans>}</Text>
    </Link>
  )
}
